import React from 'react'
import Richtext from './Richtext'
import { RiDoubleQuotesL } from 'react-icons/ri'

const RtBlockquote = ({ value: { quote, author } }) => (
	<blockquote className="relative text-orange pl-8 pt-8 pb-4 border-l-2 border-current <md:!ml-2">
		<RiDoubleQuotesL className="absolute left-0 top-0 -translate-x-1/2 bg-white text-5xl" />

		<Richtext className="h3" raw={quote} />

		{!!author && (
			<cite className="block mt-2 not-italic">— {author}</cite>
		)}
	</blockquote>
)

export default RtBlockquote
